/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { ScopeQuestionOptionalValue } from '@g17eco/types/survey';
import { QUESTION } from '@constants/terminology';
import { Column, Row } from '@g17eco/molecules/tracking-list';
import { getQuestionFullTitle } from '@utils/universalTracker';
import { getAltCode } from '@utils/alternativeCode';

interface RowEmptyProps {
  question: ScopeQuestionOptionalValue;
  rowIndex: number;
  alternativeCode?: string;
  preferredAltCodes?: string[];
}

export const RowEmpty = (props: RowEmptyProps) => {
  const { question, rowIndex, alternativeCode, preferredAltCodes } = props;
  const { universalTracker } = question;
  const title = getQuestionFullTitle(universalTracker, getAltCode(universalTracker, alternativeCode, preferredAltCodes));

  return (
    <Row key={`${universalTracker.getId()}-${rowIndex}`} className={'clickable'}>
      <Column className='pl-1' stretch truncate tooltip={`${QUESTION.CAPITALIZED_SINGULAR} not in scope`}>
        {title}
      </Column>
    </Row>
  );
}
